import { render, staticRenderFns } from "./termlyModePending.vue?vue&type=template&id=daf474c8&scoped=true"
import script from "./termlyModePending.vue?vue&type=script&lang=js"
export * from "./termlyModePending.vue?vue&type=script&lang=js"
import style0 from "./termlyModePending.vue?vue&type=style&index=0&id=daf474c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf474c8",
  null
  
)

export default component.exports